var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { loading: _vm.loading, title: _vm.title } },
    [
      _c(
        "sc-tabs",
        {
          attrs: { type: "is-boxed has-form" },
          on: { change: _vm.changeTabs },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "sc-tab-item",
            { attrs: { label: "Por volume" } },
            [_c("sc-quote-freight-by-volume")],
            1
          ),
          _vm._v(" "),
          _c(
            "sc-tab-item",
            { attrs: { label: "Por produto" } },
            [_c("sc-quote-freight-by-product")],
            1
          ),
          _vm._v(" "),
          _c(
            "sc-tab-item",
            { attrs: { label: "Simulação de cotação" } },
            [_vm.activeTab === 2 ? _c("sc-logistic-draft-test") : _vm._e()],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-492784e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492784e9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/PageFreightQuote.vue
// module id = null
// module chunks = 